<template>
  <div>
    <div class="container">
      <div class="header">
        <h4 class="title">Players</h4>
        <ul>
          <li v-for="i in playersList" :key="i.title" :class="i.class" class="players-role">
            <a href="#" v-on:click.stop.prevent="scrollTo(i.title)">{{i.title + 's'}}</a>
          </li>
        </ul>
      </div>
      <div class="content-list">
        <div v-for="i in playersList" :key="i.title" :id="i.title">
          <h6>{{i.title + 's'}}</h6>
          <div>
            <app-player
              v-for="item in i.players"
              :i="i.title"
              :item="item"
              :key="item.id"
              class="small"
            ></app-player>
          </div>
        </div>
      </div>
    </div>
    <BottomSection></BottomSection>
  </div>
</template> 
<script>
import PlayerCard from "@/components/shared/Players-card";
const url = process.env.VUE_APP_URL;

const BottomSection = () => import("@/components/shared/BottomSection");
export default {
  data() {
    return {
      playersList: [
        { title: "Goalkeeper", players: [], class: "active" },
        { title: "Defender", players: [], class: "" },
        { title: "Midfielder", players: [], class: "" },
        { title: "Forward", players: [], class: "" },
      ],
    };
  },
  methods: {
    setPlayers() {
      this.axios
        .get(url + "/participants", {
          headers: {
            "Access-Control-Allow-Origin": "*",
            accept: "application/json",
          },
        })
        .then((response) => {
          const payload = response.data;
          this.$store.dispatch("setPlayers", payload);
          this.players();
        });
    },
    players() {
      var players = this.$store.getters.players;
      this.playersList.forEach((el) => {
        players.forEach((player) => {
          if (player.participantPosition.name == el.title) {
            el.players.push(player);
          }
        });
      });
    },
    scrollTo(el) {
      document.querySelectorAll(".players-role").forEach(function (el) {
        el.classList.remove("active");
      });
      event.target.parentElement.classList.add("active");
      var offset = document.querySelector("#" + el).offsetTop - 130;
      window.scrollTo({
        top: offset,
        behavior: "smooth",
      });
    },
  },
  mounted() {
    this.players();
  },
  components: {
    "app-player": PlayerCard,
    BottomSection,
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding-top: 9.5rem;
  @media only screen and (max-width: 650px) {
    padding-top: 3rem;
  }
}
.header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  margin-bottom: 4rem;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  ul {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    @media only screen and (max-width: 650px) {
      -webkit-box-pack: start;
      -ms-flex-pack: start;
      justify-content: flex-start;
      width: 100vw;
      margin-right: -1.5rem;
      padding: 1.5rem;
      padding-left: 0;
      margin-top: 3rem;
      overflow-x: scroll;
    }
    li {
      margin-left: 1.5rem;
      &:first-of-type {
        @media only screen and (max-width: 650px) {
          margin-left: 0;
        }
      }
      &.active {
        a {
          color: #363636;
          &:after {
            width: 105%;
          }
        }
      }
    }
    li a {
      font-size: 1.4rem;
      line-height: 1.2rem;
      font-weight: 500;
      text-transform: uppercase;
      color: #a8a8a8;
      position: relative;
      transition: all 0.3s ease-in-out;
      @media only screen and (max-width: 650px) {
        font-size: 1.6rem;
        line-height: 1.6rem;
      }
      &:after {
        position: absolute;
        bottom: -1rem;
        left: 50%;
        transform: translateX(-50%);
        content: "";
        width: 0;
        height: 2px;
        border-radius: 1px;
        background: #fbbb00;
        transition: all 0.3s ease-in-out;
      }
      @media only screen and (min-width: 699px) {
        &:hover {
          color: #363636;
          &:after {
            width: 105%;
          }
        }
      }
    }
  }
}
h3 {
  margin-bottom: 0;
}
.content-list {
  div {
    margin-bottom: 5.5rem;
    @media only screen and (max-width: 650px) {
      margin-bottom: 5rem;
    }
    h6 {
      font-size: 2rem;
      text-transform: capitalize;
      margin-bottom: 5rem;
    }
    & > div {
      display: flex;
      flex-wrap: wrap;
      & > div {
        width: calc((100% - 6rem) / 3);
        //height: 37rem;
        padding-top: 14%;
        margin-right: 3rem;
        margin-bottom: 5rem;
        margin-left: 0;
        &:nth-child(3n) {
          margin-right: 0;
        }
        @media only screen and (max-width: 992px) {
          width: calc((100% - 3rem) / 2);
          padding-top: 20%;
          &:nth-child(3n) {
            margin-right: 3rem;
          }
          &:nth-child(2n) {
            margin-right: 0;
          }
        }
        @media only screen and (max-width: 650px) {
          width: 100%;
          margin-right: 0;
          padding-top: 25%;
          &:nth-child(3n) {
            margin-right: 0;
          }
        }
        @media only screen and (max-width: 399px) {
          padding-top: 30%;
        }
      }
    }
  }
}
</style>